import React from "react";

// External
import { Scrollama, Step } from "react-scrollama";
// import styled from "@emotion/styled";

// Local
import {
  Wide,
  Sidebar,
  PlotArea,
  StickyContainer,
  DatavizContainer
} from "../styled/styled";
import Section from "../component/Section/Section";
import Plot from "../component/Plot/Plot";
import { useScrollBounds } from "../lib/useScrollBounds";

const Dataviz = ({ state, data, actions }) => {
  const { stepContents } = data;
  const { currentStepValue } = state;
  const { onStepEnter } = actions;
  const [
    plotRef,
    { containerHeight, containerWidth, windowWidth, windowHeight }
  ] = useScrollBounds();
  const dim = { containerHeight, containerWidth, windowWidth, windowHeight };

  React.useEffect(() => {
    currentStepValue === 0 && actions.switchProjection("geo");
    currentStepValue === 1 && actions.switchProjection("tsne");
  }, [currentStepValue, actions]);

  return (
    <Wide className="earth wide">
      <DatavizContainer className="datavizContainer">
        <Sidebar className="sidebar">
          <Scrollama onStepEnter={onStepEnter} offset={0.5}>
            {stepContents.map((el, i) => (
              <Step key={`step${i}`} data={i}>
                <div>
                  {/* Debugging purposes
                  <p style={{ position: "fixed", top: "0" }}>
                    currentStepValue: {currentStepValue}
                  </p> */}
                  <Section
                    className="section"
                    key={`stepContent${i}`}
                    heading={el.heading}
                    paragraph={[...new Array(4)].map(
                      (p, i) => el[`paragraph${i + 1}`]
                    )}
                    organizations={el.organizations}
                    actions={actions}
                    state={state}
                  />
                </div>
              </Step>
            ))}
          </Scrollama>
        </Sidebar>
        <StickyContainer
          className="stickyContainer"
          ref={plotRef}
          style={{ height: dim.windowHeight }}
        >
          <PlotArea className="plotArea">
            <Plot state={state} data={data} actions={actions} dim={dim} />
          </PlotArea>
        </StickyContainer>
      </DatavizContainer>
    </Wide>
  );
};

export default Dataviz;
